export const cookiesName = "portalCookie";
